import client from './client';

export async function getCategoryList() {
  const res = await client.get('/admin/category');
  return res.data;
}

export async function getCategoryChildren(parentCategoryId) {
  const res = await client.get('/admin/category/children', { params: { parentCategoryId } });
  return res.data;
}

export async function createCategory(payload) {
  const res = await client.post('/admin/category', payload);
  return res.data;
}

export async function updateCategory(categoryId, payload) {
  const res = await client.put(`/admin/category/${categoryId}`, payload);
  return res.data;
}

export async function deleteCategory(categoryId) {
  const res = await client.delete(`/admin/category/${categoryId}`);
  return res.data;
}

/** 이 분류(소분류)에 속한 상품 전체를 일괄 노출/비노출 처리 */
export async function toggleCategoryDisplay(categoryId, displayYn, updatedBy) {
  const res = await client.put(`/admin/category/${categoryId}/display`, null, { params: { displayYn, updatedBy } });
  return res.data;
}
